SidebarKo = App.loadClass "core::viewmodels/filters/Sidebar"

class exports.Parent_Handler extends Handler
    init: () ->
        @layoutUrl = 'backend/portal/convert/load-layout-sidebar'
        @reports_dialog = null
        @loadLayout()


    afterLoadLayout: (selector, data) ->
        filters = [
            {
                name: '',
                filters: [
                    {
                        name: 'years'
                        display_name: 'Year'
                    },
                    {
                        name: 'states'
                        display_name: 'State'
                    },
                    {
                        name: 'zones'
                        display_name: 'Zone'
                    },
                    {
                        name: 'zips'
                        display_name: 'ZIP Code'
                    },
                    {
                        name: 'companies'
                        display_name: 'Company'
                    },
                    {
                        name: 'owners'
                        display_name: 'User'
                    },
                    {
                        name: 'farms'
                        display_name: 'Farm'
                        #class:          'dropup'
                    },
                    {
                        name: 'fields'
                        display_name: 'Field'
                        class: 'dropup'
                    },
                    {
                        name: 'brands'
                        display_name: 'Brand'
                        class: 'dropup'

                    },
                    {
                        name: 'contracts'
                        display_name: 'Contract'
                        class: 'dropup'

                    }
                ]
            }
        ]

        # Set up sidebar KO handling
        @sidebar = new SidebarKo filters
        #ko.cleanNode $(@layoutSelector)
        ko.applyBindings @sidebar, $(@layoutSelector)[0]

        # Fetch the filter data
        @sidebar.fetchFilters @filters, () =>
            # When it's loaded, open the dialog
            @reports_dialog = @createSubHandler @subHandler
            if @reports_dialog
                @reports_dialog.init()

        # Refresh when we apply filters
        $(@layoutSelector).find('.apply-filters').bind 'click', () =>
            @reports_dialog.refreshReport()

        $(@layoutSelector).find('.report-applied-filters').undelegate().delegate '.applied-filter-header', 'click', () ->
            $(this).siblings('.applied-filter-value-container').slideToggle('fast')
            if $(this).find('.caret-arrow').hasClass('caret-right')
                $(this).find('.caret-arrow').removeClass('caret-right')
            else
                $(this).find('.caret-arrow').addClass('caret-right')


    getAppliedFilters: () ->
        return @sidebar.jsonize()
